/**
 * Данные о городах для калькулятора времени полета
 */

// Основные города России
export const russianCities = [
    { id: 'moscow', name: 'Москва', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 55.7558, lon: 37.6173 } },
    { id: 'spb', name: 'Санкт-Петербург', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 59.9343, lon: 30.3351 } },
    { id: 'novosibirsk', name: 'Новосибирск', timezone: { name: 'Novosibirsk Time', offset: 7 }, coordinates: { lat: 55.0084, lon: 82.9357 } },
    { id: 'ekaterinburg', name: 'Екатеринбург', timezone: { name: 'Yekaterinburg Time', offset: 5 }, coordinates: { lat: 56.8519, lon: 60.6122 } },
    { id: 'kazan', name: 'Казань', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 55.8304, lon: 49.0661 } },
    { id: 'nizhny', name: 'Нижний Новгород', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 56.2965, lon: 43.9361 } },
    { id: 'chelyabinsk', name: 'Челябинск', timezone: { name: 'Yekaterinburg Time', offset: 5 }, coordinates: { lat: 55.1644, lon: 61.4368 } },
    { id: 'omsk', name: 'Омск', timezone: { name: 'Omsk Time', offset: 6 }, coordinates: { lat: 54.9885, lon: 73.3242 } },
    { id: 'samara', name: 'Самара', timezone: { name: 'Samara Time', offset: 4 }, coordinates: { lat: 53.1967, lon: 50.1167 } },
    { id: 'rostov', name: 'Ростов-на-Дону', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 47.2357, lon: 39.7015 } },
    { id: 'ufa', name: 'Уфа', timezone: { name: 'Yekaterinburg Time', offset: 5 }, coordinates: { lat: 54.7387, lon: 55.9721 } },
    { id: 'krasnoyarsk', name: 'Красноярск', timezone: { name: 'Krasnoyarsk Time', offset: 7 }, coordinates: { lat: 56.0184, lon: 92.8672 } },
    { id: 'perm', name: 'Пермь', timezone: { name: 'Yekaterinburg Time', offset: 5 }, coordinates: { lat: 58.0105, lon: 56.2502 } },
    { id: 'voronezh', name: 'Воронеж', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 51.6628, lon: 39.1953 } },
    { id: 'volgograd', name: 'Волгоград', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 48.7086, lon: 44.5147 } },
    { id: 'krasnodar', name: 'Краснодар', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 45.0448, lon: 38.976 } },
    { id: 'saratov', name: 'Саратов', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 51.5331, lon: 46.0215 } },
    { id: 'tyumen', name: 'Тюмень', timezone: { name: 'Yekaterinburg Time', offset: 5 }, coordinates: { lat: 57.1553, lon: 65.5619 } },
    { id: 'tolyatti', name: 'Тольятти', timezone: { name: 'Samara Time', offset: 4 }, coordinates: { lat: 53.5303, lon: 49.3461 } },
    { id: 'izhevsk', name: 'Ижевск', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 56.8498, lon: 53.2045 } },
    { id: 'barnaul', name: 'Барнаул', timezone: { name: 'Altai Time', offset: 7 }, coordinates: { lat: 53.3548, lon: 83.7698 } },
    { id: 'irkutsk', name: 'Иркутск', timezone: { name: 'Irkutsk Time', offset: 8 }, coordinates: { lat: 52.2855, lon: 104.28 } },
    { id: 'khabarovsk', name: 'Хабаровск', timezone: { name: 'Khabarovsk Time', offset: 10 }, coordinates: { lat: 48.5027, lon: 135.0986 } },
    { id: 'vladivostok', name: 'Владивосток', timezone: { name: 'Vladivostok Time', offset: 10 }, coordinates: { lat: 43.1332, lon: 131.9113 } },
    { id: 'tomsk', name: 'Томск', timezone: { name: 'Tomsk Time', offset: 7 }, coordinates: { lat: 56.4977, lon: 84.9744 } },
    { id: 'sochi', name: 'Сочи', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 43.6028, lon: 39.7342 } },
    { id: 'stavropol', name: 'Ставрополь', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 45.0428, lon: 41.9734 } },
    { id: 'ulan-ude', name: 'Улан-Удэ', timezone: { name: 'Irkutsk Time', offset: 8 }, coordinates: { lat: 51.8255, lon: 107.6139 } },
    { id: 'kaliningrad', name: 'Калининград', timezone: { name: 'Kaliningrad Time', offset: 2 }, coordinates: { lat: 54.7104, lon: 20.51 } },
    { id: 'petropavlovsk', name: 'Петропавловск-Камчатский', timezone: { name: 'Kamchatka Time', offset: 12 }, coordinates: { lat: 53.0242, lon: 158.6483 } },
    { id: 'yakutsk', name: 'Якутск', timezone: { name: 'Yakutsk Time', offset: 9 }, coordinates: { lat: 62.0339, lon: 129.733 } },
    { id: 'murmansk', name: 'Мурманск', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 68.9585, lon: 33.0827 } },
    { id: 'sevastopol', name: 'Севастополь', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 44.6166, lon: 33.5254 } },
    { id: 'simferopol', name: 'Симферополь', timezone: { name: 'Moscow Time', offset: 3 }, coordinates: { lat: 44.9521, lon: 34.1024 } }
  ];
  
  // Популярные международные города
  export const internationalCities = [
    { id: 'istanbul', name: 'Стамбул', timezone: { name: 'Turkey Time', offset: 3 }, coordinates: { lat: 41.0082, lon: 28.9784 } },
    { id: 'ankara', name: 'Анкара', timezone: { name: 'Turkey Time', offset: 3 }, coordinates: { lat: 39.9334, lon: 32.8597 } },
    { id: 'antalya', name: 'Анталья', timezone: { name: 'Turkey Time', offset: 3 }, coordinates: { lat: 36.9081, lon: 30.6953 } },
    { id: 'minsk', name: 'Минск', timezone: { name: 'Belarus Time', offset: 3 }, coordinates: { lat: 53.9, lon: 27.5667 } },
    { id: 'astana', name: 'Астана', timezone: { name: 'Astana Time', offset: 6 }, coordinates: { lat: 51.1694, lon: 71.4491 } },
    { id: 'almaty', name: 'Алматы', timezone: { name: 'Almaty Time', offset: 6 }, coordinates: { lat: 43.2775, lon: 76.8958 } },
    { id: 'baku', name: 'Баку', timezone: { name: 'Azerbaijan Time', offset: 4 }, coordinates: { lat: 40.4093, lon: 49.8671 } },
    { id: 'tashkent', name: 'Ташкент', timezone: { name: 'Uzbekistan Time', offset: 5 }, coordinates: { lat: 41.2995, lon: 69.2401 } },
    { id: 'yerevan', name: 'Ереван', timezone: { name: 'Armenia Time', offset: 4 }, coordinates: { lat: 40.1776, lon: 44.5126 } },
    { id: 'tbilisi', name: 'Тбилиси', timezone: { name: 'Georgia Time', offset: 4 }, coordinates: { lat: 41.7151, lon: 44.8271 } },
    { id: 'dubai', name: 'Дубай', timezone: { name: 'Gulf Standard Time', offset: 4 }, coordinates: { lat: 25.2532, lon: 55.3657 } },
    { id: 'abu_dhabi', name: 'Абу-Даби', timezone: { name: 'Gulf Standard Time', offset: 4 }, coordinates: { lat: 24.4539, lon: 54.3773 } },
    { id: 'tel_aviv', name: 'Тель-Авив', timezone: { name: 'Israel Time', offset: 3 }, coordinates: { lat: 32.0853, lon: 34.7818 } },
    { id: 'beirut', name: 'Бейрут', timezone: { name: 'Lebanon Time', offset: 3 }, coordinates: { lat: 33.8938, lon: 35.5018 } },
    { id: 'belgrade', name: 'Белград', timezone: { name: 'Central European Time', offset: 2 }, coordinates: { lat: 44.7866, lon: 20.4489 } },
    { id: 'beijing', name: 'Пекин', timezone: { name: 'China Standard Time', offset: 8 }, coordinates: { lat: 39.9042, lon: 116.4074 } },
    { id: 'shanghai', name: 'Шанхай', timezone: { name: 'China Standard Time', offset: 8 }, coordinates: { lat: 31.2304, lon: 121.4737 } },
    { id: 'hong_kong', name: 'Гонконг', timezone: { name: 'Hong Kong Time', offset: 8 }, coordinates: { lat: 22.3193, lon: 114.1694 } },
    { id: 'seoul', name: 'Сеул', timezone: { name: 'Korea Standard Time', offset: 9 }, coordinates: { lat: 37.5665, lon: 126.978 } },
    { id: 'tokyo', name: 'Токио', timezone: { name: 'Japan Standard Time', offset: 9 }, coordinates: { lat: 35.6762, lon: 139.6503 } },
    { id: 'bangkok', name: 'Бангкок', timezone: { name: 'Thailand Time', offset: 7 }, coordinates: { lat: 13.7563, lon: 100.5018 } },
    { id: 'delhi', name: 'Дели', timezone: { name: 'India Standard Time', offset: 5.5 }, coordinates: { lat: 28.7041, lon: 77.1025 } },
    { id: 'hanoi', name: 'Ханой', timezone: { name: 'Vietnam Time', offset: 7 }, coordinates: { lat: 21.0285, lon: 105.8542 } },
    { id: 'havana', name: 'Гавана', timezone: { name: 'Cuba Standard Time', offset: -4 }, coordinates: { lat: 23.1136, lon: -82.3666 } },
    { id: 'new_york', name: 'Нью-Йорк', timezone: { name: 'Eastern Time', offset: -4 }, coordinates: { lat: 40.7128, lon: -74.006 } },
    { id: 'london', name: 'Лондон', timezone: { name: 'Greenwich Mean Time', offset: 1 }, coordinates: { lat: 51.5074, lon: -0.1278 } },
    { id: 'paris', name: 'Париж', timezone: { name: 'Central European Time', offset: 2 }, coordinates: { lat: 48.8566, lon: 2.3522 } },
    { id: 'berlin', name: 'Берлин', timezone: { name: 'Central European Time', offset: 2 }, coordinates: { lat: 52.5200, lon: 13.4050 } },
    { id: 'rome', name: 'Рим', timezone: { name: 'Central European Time', offset: 2 }, coordinates: { lat: 41.9028, lon: 12.4964 } },
    { id: 'madrid', name: 'Мадрид', timezone: { name: 'Central European Time', offset: 2 }, coordinates: { lat: 40.4168, lon: -3.7038 } },
    { id: 'cairo', name: 'Каир', timezone: { name: 'Eastern European Time', offset: 2 }, coordinates: { lat: 30.0444, lon: 31.2357 } }
  ];
  
  /**
   * Получение информации о часовом поясе города
   * 
   * @param {string} cityName - Название города
   * @returns {Object|null} Информация о часовом поясе
   */
  export const getCityTimezone = (cityName) => {
    const city = [...russianCities, ...internationalCities].find(c => c.name === cityName);
    return city ? city.timezone : null;
  };
  
  /**
   * Расчет расстояния между городами по формуле гаверсинуса (учитывает кривизну Земли)
   * 
   * @param {string} cityName1 - Название первого города
   * @param {string} cityName2 - Название второго города
   * @returns {number} Расстояние в километрах
   */
  export const getDistanceBetweenCities = (cityName1, cityName2) => {
    // Если города одинаковые, расстояние 0
    if (cityName1 === cityName2) {
      return 0;
    }
    
    const city1 = [...russianCities, ...internationalCities].find(c => c.name === cityName1);
    const city2 = [...russianCities, ...internationalCities].find(c => c.name === cityName2);
    
    // Если не нашли один из городов, возвращаем примерное среднее расстояние
    if (!city1 || !city2) {
      return 1500; // примерное среднее расстояние для демонстрационных целей
    }
    
    // Радиус Земли в километрах
    const R = 6371;
    
    // Координаты в радианах
    const lat1 = city1.coordinates.lat * Math.PI / 180;
    const lon1 = city1.coordinates.lon * Math.PI / 180;
    const lat2 = city2.coordinates.lat * Math.PI / 180;
    const lon2 = city2.coordinates.lon * Math.PI / 180;
    
    // Разница координат
    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;
    
    // Формула гаверсинуса
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1) * Math.cos(lat2) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const distance = R * c;
    
    return distance;
  };
  
  /**
   * Получение основных авиамаршрутов России
   * 
   * @returns {Array} Список популярных маршрутов с информацией
   */
  export const getPopularRussianRoutes = () => {
    return [
      {
        from: 'Москва',
        to: 'Санкт-Петербург',
        frequency: 'Каждый час',
        distance: getDistanceBetweenCities('Москва', 'Санкт-Петербург'),
        duration: '1ч 20м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Победа', 'Россия']
      },
      {
        from: 'Москва',
        to: 'Сочи',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Москва', 'Сочи'),
        duration: '2ч 30м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Победа', 'Уральские авиалинии']
      },
      {
        from: 'Москва',
        to: 'Екатеринбург',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Москва', 'Екатеринбург'),
        duration: '2ч 20м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Уральские авиалинии']
      },
      {
        from: 'Москва',
        to: 'Краснодар',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Москва', 'Краснодар'),
        duration: '2ч 10м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Победа', 'UTair']
      },
      {
        from: 'Москва',
        to: 'Калининград',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Москва', 'Калининград'),
        duration: '2ч 10м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Победа']
      },
      {
        from: 'Москва',
        to: 'Новосибирск',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Москва', 'Новосибирск'),
        duration: '4ч 00м',
        airlines: ['Аэрофлот', 'S7 Airlines']
      },
      {
        from: 'Москва',
        to: 'Владивосток',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Москва', 'Владивосток'),
        duration: '8ч 30м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Россия']
      },
      {
        from: 'Санкт-Петербург',
        to: 'Москва',
        frequency: 'Каждый час',
        distance: getDistanceBetweenCities('Санкт-Петербург', 'Москва'),
        duration: '1ч 20м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Победа', 'Россия']
      },
      {
        from: 'Санкт-Петербург',
        to: 'Сочи',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Санкт-Петербург', 'Сочи'),
        duration: '3ч 10м',
        airlines: ['Аэрофлот', 'Россия', 'Победа']
      },
      {
        from: 'Екатеринбург',
        to: 'Москва',
        frequency: 'Каждый день',
        distance: getDistanceBetweenCities('Екатеринбург', 'Москва'),
        duration: '2ч 20м',
        airlines: ['Аэрофлот', 'S7 Airlines', 'Уральские авиалинии']
      }
    ];
  };
  
  export default {
    russianCities,
    internationalCities,
    getCityTimezone,
    getDistanceBetweenCities,
    getPopularRussianRoutes
  };